import { render } from "./CreateAffinityGroup.vue?vue&type=template&id=0c0008fc&scoped=true"
import script from "./CreateAffinityGroup.vue?vue&type=script&lang=js"
export * from "./CreateAffinityGroup.vue?vue&type=script&lang=js"

import "./CreateAffinityGroup.vue?vue&type=style&index=0&id=0c0008fc&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0008fc"]])

export default __exports__